export default __webpack_public_path__ + "media/ub.cf8170c1.jpg";